import { render, staticRenderFns } from "./_PASSPORT_PHOTO.vue?vue&type=template&id=1e8de334&"
import script from "./_PASSPORT_PHOTO.vue?vue&type=script&lang=js&"
export * from "./_PASSPORT_PHOTO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports